import { css } from 'foundations-theming/utils';
import { rgba } from '../../../transitional/utils/color';
import { setUiTransition } from '../../../transitional/components/AutoSizedTextInput/AutoSizedTextInput.helpers';
const FAB_HEIGHT = '50px';
export const getFabStyles = props => {
  const {
    theme,
    pointySide,
    $cssStyles
  } = props;
  const styles = css(["align-items:center;border-radius:20px;border-bottom-left-radius:", ";border-bottom-right-radius:", ";box-shadow:0 5px 20px 0 rgba(12,73,84,0.2);display:inline-flex;font-size:", ";line-height:normal;min-height:", ";padding:", " ", ";position:relative;", ";user-select:none;vertical-align:'middle';", ""], pointySide === 'bottom-left' && theme.borderRadius['100'], pointySide === 'bottom-right' && theme.borderRadius['100'], theme.typography['body-100'].fontSize, FAB_HEIGHT, theme.space['0'], theme.space['300'], setUiTransition('background'), Object.assign({}, $cssStyles));
  return styles;
};
export const getFabAfterStyles = props => {
  const {
    theme
  } = props;
  const styles = css(["content:'';display:block;height:", ";margin-left:-", ";width:", ";"], FAB_HEIGHT, theme.space['25'], theme.space['25']);
  return styles;
};
export const getFabBeforeStyles = props => {
  const {
    theme
  } = props;
  const styles = css(["background-color:", ";border-radius:inherit;bottom:0;content:'';display:", ";left:0;position:absolute;right:0;top:0;"], rgba(theme.color['do-not-use-monolith'], 0.1), props.active ? 'block' : 'none');
  return styles;
};
export const getFabMinimizedStyles = () => {
  const styles = css(["border-start-start-radius:0;border-end-start-radius:0;left:var(--global-nav-vertical-nav-width,0);"]);
  return styles;
};
const hoveredStyles = css(["color:", ";background-color:", ";"], ({
  theme
}) => `${theme.color['text-core-on-fill-default']}`, ({
  theme
}) => `${theme.color['temp-future-fill-accent-teal-pressed']}`);
const blueOceanGradient = css(["color:", ";background-color:", ";background-image:linear-gradient( 89deg,", " ) !important;"], ({
  theme
}) => `${theme.color['text-core-on-fill-default']}`, ({
  theme
}) => `${theme.color['temp-future-fill-accent-teal-default']}`, ({
  theme
}) => `${theme.color['temp-future-fill-accent-teal-default']}, ${theme.color['fill-positive-default']}`);
export const getFabBetaButtonStyles = props => {
  const {
    hovered
  } = props;
  const styles = css(["", " position:fixed;bottom:17px;left:calc(var(--global-nav-vertical-nav-width,0) + 17px);z-index:900;"], hovered ? hoveredStyles : blueOceanGradient);
  return styles;
};